import React, { useEffect, useState, forwardRef, useImperativeHandle } from "react";
import { FormattedMessage } from "react-intl";
import { useValidationErrorHandle } from "sr/helpers/functions/validationErrorHandle";
import { CheckBox } from "sr/helpers/ui-components/company/CheckBox";
import CheckBoxHandle from "sr/helpers/functions/CheckBoxHandle";
import { serviceTypes as serviceTypeStatic } from "../../requirement-post/RequirementJsonData";

type Props = {
  data: { service_type?: string[] };
  HandleDataProps: (payload: { service_type: string[] }) => void;
  externalErrorId?: string;
};

const RequirementServiceTypesChange = forwardRef(({ data, HandleDataProps, externalErrorId }: Props, ref) => {
  const validationErrorHandle = useValidationErrorHandle();
  const [selected, setSelected] = useState<string[]>([]);
  const [options, setOptions] = useState<{ value: string; label: string }[]>(serviceTypeStatic);
  const [error, setError] = useState("");

  useEffect(() => {
    setSelected(data?.service_type || []);
  }, [data?.service_type]);

  useEffect(() => {
    HandleDataProps({ service_type: selected });
  }, [selected]);

  useImperativeHandle(ref, () => ({
    validateData: () => {
      if (!selected || selected.length === 0) {
        setError("Please select at least one Service Type");
        return false;
      }
      setError("");
      return true;
    },
    submitForm: () => ({ service_type: selected }),
  }));

  return (
    <div>
      <p className="pt-4 text-base">Service Types</p>
      <div className="flex flex-wrap gap-4 mt-2">
        {options.map((st, index) => (
          <CheckBox
            key={index}
            value={st.value} 
            label={<FormattedMessage id={st.label} defaultMessage={st.label} />}
            onChange={(e) => CheckBoxHandle(e, selected, setSelected)}
            checked={selected.includes(st.value)}
          />
        ))}
      </div>
      {(externalErrorId || error) && <div className="text-red-500 text-sm mt-2">{externalErrorId ? validationErrorHandle(externalErrorId) : error}</div>}
    </div>
  );
});

export default RequirementServiceTypesChange;
